import { useState } from "react";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { GitMerge } from "lucide-react";

import { orpc } from "@/client";
import type { SystemDecision } from "@/api/db/system-decisions";
import { ToneChip } from "@/components/medico/tone-chip";
import { OperacaoLabels } from "@/lib/labels/operacao";
import { SystemLabels } from "@/lib/labels/system";

import { LogListSection, LogRow } from "./log-list";

export function DecisionsSection() {
	const [page, setPage] = useState(1);

	const { data, isLoading, isError } = useQuery(
		orpc.system.decisions.queryOptions({ input: { page }, placeholderData: keepPreviousData }),
	);

	return (
		<LogListSection
			title={SystemLabels.sections.decisions}
			dataComponent="system-decisions"
			emptyIcon={GitMerge}
			emptyTitle={SystemLabels.empty.decisions}
			isLoading={isLoading}
			isError={isError}
			data={data}
			page={page}
			onPage={setPage}
			rowKey={(row) => row.id}
			renderRow={(row) => <DecisionRow row={row} />}
		/>
	);
}

function DecisionRow({ row }: { row: SystemDecision }) {
	return (
		<LogRow
			data-slot="decision"
			data-resolution={row.resolution}
			person={row.person}
			chip={<ToneChip tone="neutral">{SystemLabels.decisionField(row.field)}</ToneChip>}
			when={OperacaoLabels.moment(row.created_at)}
			detail={SystemLabels.decisionResolution(row.resolution)}
		/>
	);
}
